import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IAudience } from '../../../../models/audience';
import { find, propEq } from 'ramda/es';

@Component({
  selector: 'select-audience',
  template: `
    <select
      class="form-control select"
      name="audience"
      [(ngModel)]="selectedAudience"
      (change)="onChange(selectedAudience)"
      required
    >
      <option [ngValue]="undefined" disabled>{{
        'sessions.edit.live_mode.activation.audience_select' | translate
      }}</option>
      <option *ngFor="let audience of audiences" [ngValue]="audience"
        >&lt;
        {{
          'sessions.edit.live_mode.activation.audience_select_choice'
            | translate: { audience: audience.value }
        }}
      </option>
    </select>
  `,
  styles: [``]
})
export class SelectAudienceComponent implements OnInit {
  @Input() audience: number = undefined;
  @Output() selectedAudienceChange: EventEmitter<IAudience> = new EventEmitter();

  public selectedAudience: IAudience;
  public audiences: IAudience[] = [
    { value: 50, multiplicator: 1 },
    { value: 100, multiplicator: 1.5 },
    { value: 200, multiplicator: 2 },
    { value: 300, multiplicator: 3 },
    { value: 500, multiplicator: 4 }
  ];

  constructor() {}

  ngOnInit() {
    if (this.audience >= 0) {
      this.selectedAudience = find(propEq('value', this.audience))(this.audiences);
      this.selectedAudienceChange.emit(this.selectedAudience);
    }
  }

  onChange(audience: IAudience) {
    this.selectedAudienceChange.emit(audience);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/live-mode/audience/audience-select.component.ts